// react-scripts sets NODE_ENV automatically: "development" only under `yarn start`,
// "production" under `yarn build` — unlike REACT_APP_IS_LOCAL_DEV, a build script
// can't silently inherit the wrong value for this from the checked-in .env.
export const isLocalDev = process.env.NODE_ENV === "development";

// In local dev the app is served from CRA's own dev server (e.g. localhost:3000),
// which isn't where the auth API lives, so REACT_APP_AUTH_API is used as an
// explicit override there. Once deployed, this page is served from the same
// domain the auth API is on (imperialdade.com or imperialbrady.com), so the
// auth API is derived from the current origin instead of a single hardcoded
// domain baked in at build time — letting one build serve every domain.
export const AUTH_API = isLocalDev
  ? process.env.REACT_APP_AUTH_API
  : `${window.location.origin}${process.env.PUBLIC_URL || ""}`;
